import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import {
  PostHeader,
  PostImage,
  PostHeaderText,
  PostHeaderCategory,
  PostHeaderHeading,
  PostHeaderMeta,
  PostHeaderExcerpt,
  PostMain,
} from "./PostElements"
import { readTime } from "../../../utilities/readTime"

import Author from "./Author"

const index = ({ post }) => {
  const featuredImage = {
    data: post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData,
    alt: post.featuredImage?.node?.alt || ``,
  }
  const time = readTime(post.content)
  const image = post.writer.writer.writerinfo.profileImage.localFile
  console.log(image)

  return (
    <>
      <PostHeader>
        <PostImage>
          <GatsbyImage
            image={featuredImage.data}
            alt={featuredImage.alt}
            style={{ height: "100%", width: "100%" }}
            imgStyle={{ objectFit: "cover" }}
          />
        </PostImage>
        <PostHeaderText>
          <PostHeaderCategory>
            {post.categories.nodes[0].name}
          </PostHeaderCategory>
          <PostHeaderHeading>{post.title}</PostHeaderHeading>
          <PostHeaderMeta>
            By {post.writer.writer.title} | {time}
          </PostHeaderMeta>
          <PostHeaderExcerpt
            dangerouslySetInnerHTML={{ __html: `${post.excerpt}` }}
          ></PostHeaderExcerpt>
        </PostHeaderText>
      </PostHeader>
      <PostMain dangerouslySetInnerHTML={{ __html: `${post.content}` }} />

      {image.childImageSharp.gatsbyImageData &&
        post.writer.writer.title &&
        post.writer.writer.writerinfo.bio && (
          <Author
            img={image.childImageSharp.gatsbyImageData}
            alt={post.writer.writer.writerinfo.profileImage.altText}
            name={post.writer.writer.title}
            bio={post.writer.writer.writerinfo.bio}
          />
        )}
    </>
  )
}

export default index
